const DeleteTask = ({ todo, index, handleDeleteTask }) => {
  return (
    <div>
      <button
        className="btn btn-danger m-3"
        onClick={() => {
          handleDeleteTask(index);
        }}
      >
        Delete Task
      </button>
    </div>
  );
};

export default DeleteTask;
